import { List, Datagrid, TextField, EditButton } from 'react-admin';
import FormattedDateTimeField from '../../common/FormattedDateTimeField';
import { AssignPermissions } from './AssignPermissionModal';
import PermissionBasedActions from '../../common/PermissionBasedActionsButton';
import useIsPermission from '../../hooks/useIsPermission';
import ConfirmDeleteButton from '../../common/ConfirmDeleteButton';

const RoleList = () => {
    const { isWritable } = useIsPermission('ACCESS_CONTROL');
    return (
        <div>
            <List actions={<PermissionBasedActions isWritable={isWritable} />}>
                <Datagrid>
                    <TextField source="name" />
                    <FormattedDateTimeField source="created_at" />
                    <AssignPermissions />
                    <EditButton />
                    <ConfirmDeleteButton />
                </Datagrid>
            </List>
        </div>
    );
};
export default RoleList;
